export const getIdleTimeSummaryColumns = (t) => ([
  {
    id: 'vehicleName',
    label: t('drivingJournal.idleTimeReport.vehicle'),
    width: 260,
    hide: [],
    align: 'left'
  },
  {
    id: 'vin',
    label: t('drivingJournal.idleTimeReport.vin'),
    minWidth: 200,
    hide: [],
    align: 'left'
  },
  {
    id: 'eventCount',
    label: t('drivingJournal.idleTimeReport.idleEvents'),
    minWidth: 200,
    hide: [],
    align: 'left'
  },
  {
    id: 'totalIdleDuration',
    label: t('drivingJournal.idleTimeReport.totalIdleDuration'),
    minWidth: 200,
    hide: [],
    align: 'left'
  }
])

export const getIdleTimeDetailColumns = (t) => ([
  {
    id: 'date',
    label: t('drivingJournal.idleTimeReport.date'),
    isSortable: true,
    width: 200,
    isSmallColumn: true,
    align: 'left'
  },
  {
    id: 'time',
    label: t('drivingJournal.idleTimeReport.time'),
    isSortable: true,
    width: 130,
    isSmallColumn: true,
    align: 'left'
  },
  {
    id: 'duration',
    label: t('drivingJournal.idleTimeReport.idleDuration'),
    isSortable: true,
    width: 169,
    align: 'left'
  }
])
